import { render, staticRenderFns } from "./SubjectEdit.vue?vue&type=template&id=487d2c3d&scoped=true&"
import script from "./SubjectEdit.vue?vue&type=script&lang=js&"
export * from "./SubjectEdit.vue?vue&type=script&lang=js&"
import style0 from "./SubjectEdit.vue?vue&type=style&index=0&id=487d2c3d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487d2c3d",
  null
  
)

export default component.exports